import {HitFormService} from '../../../../api';
import {makeEntityStore} from '../../../helpers/factory';
// Deep import: the models barrel also loads form/validation → FormUtils → @hit/base (TDZ on Form).
import Form from '../../../../models/hit/form/Form';
import {formSchema} from '../../../../models/hit/form/schema';

export default makeEntityStore({
  modelCls: Form,
  service: new HitFormService(),
  schema: formSchema,
});
